import { DEFAULT_PALETTE } from '../../core/palette';
import type { ParamSchema, SchemaValues } from '../../core/params/types';

export const TEXT_FROM_TEXT_PARAMS = [
  {
    kind: 'text',
    key: 'fillText',
    label: 'Füllwort',
    default: 'form und feld ',
    group: 'Füllung',
    tooltip: 'Wird endlos wiederholt, bis die Buchstaben gefüllt sind.',
    bulkValues: ['form und feld ', 'wachstum ', 'struktur rauschen ', 'typo typo '],
  },
  {
    kind: 'enum',
    key: 'path',
    label: 'Pfadverlauf',
    default: 'horizontal',
    group: 'Füllung',
    options: [
      { value: 'horizontal', label: 'Waagrecht' },
      { value: 'vertical', label: 'Senkrecht' },
      { value: 'spiral', label: 'Spirale' },
      { value: 'contour', label: 'Entlang der Kontur' },
      { value: 'flow', label: 'Entlang eines Flow Fields' },
    ],
  },
  {
    kind: 'float',
    key: 'fontSize',
    label: 'Schriftgrösse',
    min: 3,
    max: 80,
    step: 0.5,
    scale: 'log',
    default: 13,
    unit: 'px',
    bulkRange: [6, 30],
    group: 'Füllung',
  },
  {
    kind: 'float',
    key: 'lineHeight',
    label: 'Zeilenabstand',
    min: 0.6,
    max: 3,
    step: 0.01,
    default: 1.05,
    unit: '×',
    group: 'Füllung',
  },
  {
    kind: 'float',
    key: 'tracking',
    label: 'Laufweite',
    min: -0.3,
    max: 1.5,
    step: 0.01,
    default: 0.02,
    unit: 'em',
    group: 'Füllung',
  },
  {
    kind: 'enum',
    key: 'edge',
    label: 'Randbehandlung',
    default: 'clip',
    segmented: true,
    group: 'Füllung',
    options: [
      { value: 'clip', label: 'Beschneiden' },
      { value: 'skip', label: 'Ganze Zeichen' },
    ],
    tooltip: 'Beschneiden ergibt harte Kanten, ganze Zeichen einen ausgefransten Rand.',
  },
  {
    kind: 'float',
    key: 'noiseScale',
    label: 'Feld-Skala',
    min: 0.0004,
    max: 0.02,
    step: 0.0001,
    scale: 'log',
    default: 0.0024,
    precision: 4,
    unit: '1/px',
    group: 'Füllung',
    showIf: (v) => v.path === 'flow',
  },
  {
    kind: 'float',
    key: 'spiralPitch',
    label: 'Spiralabstand',
    min: 2,
    max: 80,
    step: 0.5,
    default: 16,
    unit: 'px',
    group: 'Füllung',
    showIf: (v) => v.path === 'spiral',
  },
  {
    kind: 'float',
    key: 'contourOffset',
    label: 'Konturabstand',
    min: 1,
    max: 60,
    step: 0.5,
    default: 13,
    unit: 'px',
    group: 'Füllung',
    showIf: (v) => v.path === 'contour',
  },

  {
    kind: 'float',
    key: 'opacity',
    label: 'Deckkraft',
    min: 0.05,
    max: 1,
    step: 0.01,
    default: 1,
    group: 'Farbe',
  },
  {
    kind: 'enum',
    key: 'colorMode',
    label: 'Farbmodus',
    default: 'position',
    group: 'Farbe',
    options: [
      { value: 'solid', label: 'Einfarbig' },
      { value: 'position', label: 'Nach Position' },
      { value: 'depth', label: 'Nach Tiefe' },
      { value: 'sequence', label: 'Nach Reihenfolge' },
    ],
  },
  {
    kind: 'palette',
    key: 'palette',
    label: 'Palette',
    default: { ...DEFAULT_PALETTE, paletteId: 'bauhaus' },
    group: 'Farbe',
  },
] as const satisfies ParamSchema;

export type TextFromTextValues = SchemaValues<typeof TEXT_FROM_TEXT_PARAMS>;
